<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted() {
    
  }
}
</script>
<style lang="scss">
* {
  box-sizing: border-box;
}
html body {
  margin: 0;
}
// 页面两侧背景（PC 端可见）：深灰 + 顶部金色光晕，避免整屏纯黑
html,
body {
  min-height: 100%;
  background-color: #1c1c1e;
  background-image: radial-gradient(
      60% 45% at 50% 0%,
      rgba(248, 191, 84, 0.22) 0%,
      rgba(248, 191, 84, 0) 100%
    ),
    linear-gradient(180deg, #2c2c2e 0%, #1c1c1e 100%);
  background-attachment: fixed;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // PC 端按移动端布局居中显示，10rem 即手机满宽（最大 500px，见 utils/remCap.js）
  width: 100%;
  max-width: 10rem;
  min-height: 100vh;
  margin: 0 auto;
  position: relative;
}
@media (min-width: 500px) {
  #app {
    box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.6);
  }
}
.mini-toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  z-index: 9999;
  opacity: 1;
  transition: opacity 0.3s;
  font-size: 16px;
}
.mini-toast.fade-out {
  opacity: 0;
}
</style>
